const ru = {
  nav: {
    home: "Главная",
    register: "Регистрация",
    login: "Войти",
    support: "Поддержка",
    logout: "Выход",
    pricing: "Тарифы",
  },
  home: {
    hero_tag: "Для граждан Азербайджана",
    hero_title: "Безопасный Email Сервис",
    hero_subtitle: "Верифицированные аккаунты на основе ФИН. Безопасность данных по государственным стандартам.",
    hero_cta: "Зарегистрироваться",
    hero_login: "Войти",
    features_title: "Почему Mail.net.az?",
    features_subtitle: "Сделано азербайджанцами для азербайджанцев",
    feature1_title: "Верификация по ФИН",
    feature1_desc: "Только для граждан Азербайджана. Аккаунты, полностью подтверждённые с помощью ФИН-кода удостоверения личности.",
    feature2_title: "Доступность 99.9%",
    feature2_desc: "Серверная инфраструктура по государственным стандартам. Мониторинг 24/7 и бесперебойный сервис.",
    feature3_title: "Сквозное Шифрование",
    feature3_desc: "Все письма защищены шифрованием AES-256. Полная гарантия конфиденциальности.",
    feature4_title: "Многоязычный Интерфейс",
    feature4_desc: "Поддержка языков AZ, RU, EN. Удобный и привычный интерфейс.",
    stats_label: "Mail.net.az в цифрах",
    stats_desc: "Самая надёжная платформа email-хостинга в Азербайджане. Тысячи граждан уже доверяют Mail.net.az.",
    stat1_num: "25,000+",
    stat1_label: "Активных пользователей",
    stat2_num: "99.9%",
    stat2_label: "Доступность сервера",
    stat3_num: "24/7",
    stat3_label: "Техническая поддержка",
    stat4_num: "100%",
    stat4_label: "Граждане АЗ",
    reviews_title: "Что Говорят Наши Пользователи",
    reviews_label: "Отзывы пользователей",
    cta_title: "Создайте Свой Безопасный Email Аккаунт",
    cta_subtitle: "Регистрация за 5 минут. Полнофункциональный аккаунт с подтверждением ФИН.",
    cta_btn: "Начать Регистрацию",
  },
  register: {
    title: "Создать Новый Аккаунт",
    subtitle: "Эксклюзивно для граждан Азербайджана",
    firstname: "Имя",
    lastname: "Фамилия",
    email: "Email адрес",
    email_placeholder: "имя.фамилия@mail.net.az",
    fin: "ФИН Номер",
    fin_placeholder: "7-значный ФИН-код",
    id_serial: "Серия удостоверения",
    id_serial_placeholder: "AZE",
    id_number: "Номер удостоверения",
    id_number_placeholder: "00000000",
    phone: "Номер телефона",
    phone_placeholder: "+994 50 000 00 00",
    password: "Пароль",
    password_placeholder: "Минимум 8 символов",
    confirm_password: "Повтор пароля",
    confirm_password_placeholder: "Введите пароль повторно",
    terms: "Я принимаю условия использования",
    terms_link: "Условия",
    btn: "Завершить регистрацию",
    already: "Уже есть аккаунт?",
    login_link: "Войти",
    feature1: "Полная верификация по ФИН",
    feature2: "Государственные стандарты",
    feature3: "Полная конфиденциальность",
    fin_info: "Ваш ФИН можно найти на удостоверении личности",
    success: "Ваша заявка на регистрацию принята!",
    success_msg: "В ближайшее время вам будет отправлено уведомление на email.",
    error_fin: "ФИН должен состоять из 7 цифр",
    error_password: "Пароли не совпадают",
    error_terms: "Необходимо принять условия",
  },
  login: {
    title: "Войти в Аккаунт",
    subtitle: "Добро пожаловать на портал Mail.net.az",
    email: "Email адрес",
    email_placeholder: "имя.фамилия@mail.net.az",
    password: "Пароль",
    password_placeholder: "Введите ваш пароль",
    remember: "Запомнить меня",
    forgot: "Забыли пароль?",
    btn: "Войти",
    fin_btn: "Войти по ФИН",
    or: "или",
    no_account: "Нет аккаунта?",
    register_link: "Зарегистрироваться",
    secure: "Защищённое SSL-соединение",
    fin_modal_title: "Войти по ФИН",
    fin_modal_desc: "Введите ваш ФИН-номер и пароль",
    fin_modal_fin: "ФИН Номер",
    fin_modal_pass: "Пароль",
    fin_modal_btn: "Подтвердить",
    fin_modal_close: "Закрыть",
  },
  support: {
    hero_title: "Как Мы Можем Вам Помочь?",
    hero_placeholder: "Введите ваш вопрос...",
    contact1_title: "Телефонная поддержка",
    contact1_num: "+994 12 000 00 00",
    contact1_hours: "Пн-Пт 09:00 - 18:00",
    contact2_title: "Email поддержка",
    contact2_addr: "support@mail.net.az",
    contact2_time: "Ответ в течение 24 часов",
    contact3_title: "Живой Чат",
    contact3_btn: "Начать сейчас",
    contact3_status: "Сейчас активен",
    faq_title: "Часто Задаваемые Вопросы",
    faq_subtitle: "Ответы на самые популярные вопросы",
    form_title: "Напишите Нам",
    form_name: "Имя Фамилия",
    form_email: "Email",
    form_subject: "Тема",
    form_message: "Ваше сообщение",
    form_btn: "Отправить",
    form_success: "Ваше сообщение отправлено! Мы ответим в ближайшее время.",
    office_title: "Информация об Офисе",
    office_addr: "г. Баку, Нариманов р-н, ул. Ахмед Джавад, 20",
    office_hours: "Пн-Пт: 09:00 - 18:00",
    office_weekend: "Суббота: 10:00 - 15:00",
  },
  pricing: {
    hero_tag: "Прозрачные цены",
    hero_title: "Выберите подходящий тариф",
    hero_subtitle: "Во всех планах включена ФИН-верификация и безопасность по государственным стандартам.",
    monthly: "Ежемесячно",
    annual: "Ежегодно",
    annual_badge: "2 месяца бесплатно",
    popular: "Самый популярный",
    plan1_name: "Личный",
    plan1_desc: "Идеальный стартовый пакет для индивидуальных пользователей",
    plan1_price_monthly: "Бесплатно",
    plan1_price_annual: "Бесплатно",
    plan2_name: "Бизнес",
    plan2_desc: "Мощное решение для малого и среднего бизнеса",
    plan2_price_monthly: "₼15",
    plan2_price_annual: "₼12",
    plan3_name: "Корпоративный",
    plan3_desc: "Полнофункциональный пакет для крупных организаций",
    plan3_price_monthly: "₼49",
    plan3_price_annual: "₼39",
    per_month: "/мес",
    get_started: "Начать",
    contact_sales: "Связаться с продажами",
    current_plan: "Текущий план",
    feature_table_title: "Сравнение планов",
    feature_table_subtitle: "Сравните функции каждого плана",
    cta_title: "Ещё не определились?",
    cta_subtitle: "Обсудите ваши бизнес-потребности с нами — вместе найдём подходящий план.",
    cta_btn: "Поговорить с экспертом",
    month_short: "мес",
  },
  footer: {
    desc: "Mail.net.az — безопасный email-хостинг на основе ФИН для граждан Азербайджана.",
    services: "УСЛУГИ",
    email_hosting: "Email Хостинг",
    domain: "Регистрация доменов",
    ssl: "SSL Сертификат",
    help: "ПОДДЕРЖКА",
    faq: "FAQ",
    contact: "Контакты",
    docs: "Документация",
    legal: "ПРАВОВОЕ",
    terms: "Условия использования",
    privacy: "Политика конфиденциальности",
    gdpr: "GDPR",
    copyright: "© 2025 Mail.net.az. Все права защищены.",
  },
};

export default ru;
